import { useEffect, useState } from 'react';
import './App.css';

function App() {
	const [typedText, setTypedText] = useState('');
	const [typingDone, setTypingDone] = useState(false);

	useEffect(() => {
		document.title = 'Oleksandr Ivashchenko | Terminal Portfolio';
		const fullText = '> Oleksandr Ivashchenko';
		let i = 0;
		const interval = setInterval(() => {
			i++;
			setTypedText(fullText.slice(0, i));
			if (i === fullText.length) {
				clearInterval(interval);
				setTypingDone(true);
			}
		}, 60);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const handleKeyDown = (e) => {
			const key = e.key;
			if (key >= '1' && key <= '5') {
				const link = document.querySelector(`[data-key="${key}"]`);
				if (link) link.click();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, []);

	return (
		<>
			<div className="fixed inset-0 pointer-events-none z-[100] crt-overlay opacity-30" />
			<div className="fixed inset-0 pointer-events-none z-[101] scanline h-screen w-full" />

			<main className="min-h-screen matrix-bg">
				<nav className="px-margin-md md:px-margin-lg max-w-container-max mx-auto pt-8 pb-4">
					<div className="relative p-4 font-label-mono text-xs">
						<div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-primary/50" />
						<div className="absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 border-primary/50" />
						<div className="absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 border-primary/50" />
						<div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-primary/50" />
						<div className="flex flex-wrap items-center gap-6 relative">
							<span className="text-secondary opacity-60">[ NAV_LINKS ]</span>
							<a href="https://github.com/alexivashchenko" target="_blank" rel="noopener noreferrer" data-key="1" className="flex items-center gap-2 text-primary hover:underline transition-all group">
								<span className="material-symbols-outlined text-sm">code</span>
								<span>GitHub</span>
								<span>[1]</span>
							</a>
							<a href="https://www.linkedin.com/in/oleksandr-ivashchenko-4403a561/" target="_blank" rel="noopener noreferrer" data-key="2" className="flex items-center gap-2 text-primary hover:underline transition-all group">
								<span className="material-symbols-outlined text-sm">account_circle</span>
								<span>LinkedIn</span>
								<span>[2]</span>
							</a>
							<a href="https://t.me/+380634965817" target="_blank" rel="noopener noreferrer" data-key="3" className="flex items-center gap-2 text-primary hover:underline transition-all group">
								<span className="material-symbols-outlined text-sm">send</span>
								<span>Telegram</span>
								<span>[3]</span>
							</a>
							<a href="https://wa.me/380634965817" target="_blank" rel="noopener noreferrer" data-key="4" className="flex items-center gap-2 text-primary hover:underline transition-all group">
								<span className="material-symbols-outlined text-sm">chat</span>
								<span>WhatsApp</span>
								<span>[4]</span>
							</a>
							<a href="mailto:lex.ivashchenko@gmail.com" data-key="5" className="flex items-center gap-2 text-primary hover:underline transition-all group">
								<span className="material-symbols-outlined text-sm">mail</span>
								<span>Email</span>
								<span>[5]</span>
							</a>
						</div>
					</div>
				</nav>

				<section className="flex flex-col justify-center px-margin-md md:px-margin-lg max-w-container-max mx-auto py-section-gap-mobile md:py-margin-lg">
					<div className="font-label-mono text-primary text-lg mb-4 opacity-80">$ whoami</div>
					<h1 className="font-display text-display-mobile md:text-display text-primary terminal-text-shadow mb-8 leading-none">
						{typedText}<span className={`${typingDone ? 'blink' : ''}`}>_</span>
					</h1>
					<p className="font-body-lg text-body-lg text-secondary max-w-2xl mb-12">Turning complex problems into elegant, functional web experiences.</p>
				</section>

				<section className="px-margin-md md:px-margin-lg max-w-container-max mx-auto py-margin-lg" id="stack">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-gutter">
						<div>
							<h2 className="font-headline-lg text-headline-lg-mobile md:text-headline-lg text-primary terminal-text-shadow mb-8">./Tech_Stack</h2>
							<div className="relative p-8 font-label-mono text-sm">
								<div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary/50" />
								<div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary/50" />
								<div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary/50" />
								<div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary/50" />
								<div className="flex flex-wrap gap-3 relative">
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Laravel</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">VueJS</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">InertiaJS</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Docker</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">AWS</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Golang</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Fiber</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Python</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">SASS</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">SQL</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Vite</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Terraform</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">PostgreSQL</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">MySQL</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Caddy</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Coraza</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">NGINX</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">REST API</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">MongoDB</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">MinIO</span>
									<span className="px-4 py-2 bg-surface-container-lowest border border-outline-variant font-label-mono text-xs hover:border-primary transition-colors cursor-default">Keycloak</span>
								</div>
							</div>
						</div>
						<div>
							<h2 className="font-headline-lg text-headline-lg-mobile md:text-headline-lg text-primary terminal-text-shadow mb-8">./Experience</h2>
							<div className="relative p-8 font-label-mono text-sm">
								<div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary/50" />
								<div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary/50" />
								<div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary/50" />
								<div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary/50" />
								<div className="space-y-8 relative">
									<div className="relative">
										<span className="text-primary">APRIL 2020 - PRESENT</span>
										<p className="mt-1 text-white">Solution Architect and Full Stack Developer @ PlatX</p>
										<p className="text-xs text-secondary mt-2 opacity-80">&gt; Dubai, UAE. In5 Tech, HD 43A</p>
									</div>
									<div className="relative">
										<span className="text-primary">OCTOBER 2019 - FEBRUARY 2020</span>
										<p className="mt-1 text-white">Web Software Developer @ Jetex</p>
										<p className="text-xs text-secondary mt-2 opacity-80">&gt; Dubai, UAE. Phase 6 East Building, Dubai Airport Free Zone</p>
									</div>
									<div className="relative">
										<span className="text-primary">JANUARY 2019 - JUNE 2019</span>
										<p className="mt-1 text-white">Web Software Developer @ Liftable Media Inc</p>
										<p className="text-xs text-secondary mt-2 opacity-80">&gt; Anthem, AZ, USA</p>
									</div>
									<div className="relative">
										<span className="text-primary">JANUARY 2019 - JUNE 2019</span>
										<p className="mt-1 text-white">Web Software Developer @ NCube Ltd</p>
										<p className="text-xs text-secondary mt-2 opacity-80">&gt; London, EC2A, UK</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="px-margin-md md:px-margin-lg max-w-container-max mx-auto py-8 flex flex-col md:flex-row justify-between items-center text-xs font-label-mono text-secondary border-t border-outline-variant gap-4 mt-12">
					<div className="flex items-center gap-4">
						<span className="flex items-center gap-2">
							<span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
							STATUS: ONLINE
						</span>
						<span className="opacity-40">|</span>
						<span>LATENCY: 24ms</span>
					</div>
					<div className="text-center opacity-60">
						&copy; 2024 Oleksandr Ivashchenko &mdash; ALL_RIGHTS_RESERVED
					</div>
					<div className="flex items-center gap-4">
						<span>V.2.0.48-STABLE</span>
					</div>
				</div>
			</main>
		</>
	);
}

export default App;
